<template>
  <div class="gc-record" style="display: flex">
    <div class="gc-grid-item-container">
      <div class="gc-grid-description">
        {{ data.data[primary[0].dataField] }}
      </div>
      <div
        v-for="(item, index) in secondaryItems"
        :key="index"
        class="record-secondary gc-grid-code"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    primary: {
      type: Array,
    },
    secondary: {
      type: Array,
    },
    showImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasImage: this.showImage,
    };
  },
  computed: {
    secondaryItems() {
      let secondaryArr = [];
      let str = "";
      this.secondary.forEach((el, i) => {
        if (el.position === "below") {
          if (str) {
            secondaryArr.push(str);
            str = "";
          }
          if (
            i == this.secondary.length - 1 ||
            (this.secondary[i + 1] !== undefined &&
              this.secondary[i + 1].position === "below")
          )
            secondaryArr.push(this.data.data[el.dataField]);
          else str = str + this.data.data[el.dataField];
        } else if (el.position === "append" || !el.position) {
          str = str
            ? str + " " + this.data.data[el.dataField]
            : this.data.data[el.dataField];
          if (i == this.secondary.length - 1) {
            secondaryArr.push(str);
            str = "";
          }
        }
      });
      return secondaryArr;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.record-secondary {
  font-size: 10px;
  text-align: left;
  color: grey;
}

.gc-grid-description {
  font-size: 14px;
  text-align: left;
  max-height: 2.4em;
  line-height: 1.2;
  overflow: hidden;
}
</style>
